import auth from "@/services/CRMinitAuth"

const list = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}reserved_exams/grouped/`, {
    params: query
  });
}
export default {
  list
}